module.exports = __webpack_public_path__ + "img/Shopping Cart Remove.73324941.svg";